module.exports = __webpack_public_path__ + "assets/img/title-ec135eb6.png";